import { io } from "socket.io-client";
import { baseURL } from "../config/config";

// ✅ Define Your Backend URL (Replace with Your Server Address)
const SOCKET_SERVER_URL = baseURL.split("/api")[0]; // Change to production URL if needed
console.log("SOCKET_SERVER_URL",SOCKET_SERVER_URL);

const token = localStorage.getItem("token") || "asdasd";

// ✅ Connect to the WebSocket Server
const socket = io(SOCKET_SERVER_URL, {
  auth: { token: token },
  query: { roomId: "defaultRoom" },
  transports: ["websocket"], // Ensure WebSocket transport
  reconnection: true, // Enable auto-reconnection
  reconnectionAttempts: 5, // Number of reconnection attempts
  reconnectionDelay: 2000, // Delay before attempting reconnection
});

// ✅ Handle Connection Events
socket.on("connect", () => {
  console.log("✅ Connected to Socket Server:", socket.id);
});



socket.on("disconnect", (reason) => {
  console.warn("⚠️ Disconnected from Socket Server:", reason);
});

// ✅ Export the Socket Instance
export default socket;
